import type { TValidatorValue } from '@alfa-bank/site-form-helpers/src/validation/models';
import { getNumbersFromStr } from '@alfa-bank/site-form-helpers/text/get-numbers-from-str';
import { composeValidators } from '@alfa-bank/site-form-helpers/validation/utils';

const DEFAULT_KPP_MESSAGE = 'Некорректный КПП';

// http://confluence.moscow.alfaintra.net/pages/viewpage.action?pageId=39388355
export const isValidKpp = (value: TValidatorValue, allValues: object) => {
    const { inn } = allValues as { inn: string };

    if (inn?.length === 12) {
        return undefined;
    }
    // Полнота формата 9 символов
    if (getNumbersFromStr(value)?.length !== 9) {
        return DEFAULT_KPP_MESSAGE;
    }

    return undefined;
};

export const validateKpp = () => composeValidators(isValidKpp);
